import { Dialogs } from '@leverege/ui-elements';
import { GlobalState, UI } from '@leverege/ui-redux';
import MapKeyResponsive from './MapKeyResponsive';
export default {
  id: 'map.keyButton',
  name: 'Map Key',
  layout: {
    sort: 'zzzzzzz'
  },
  matches: {
    use: 'topLeftActionBar',
    client: ['MapDataViewer', 'GoogleMapsDataViewer'],
    objectType: ['vehicle', 'locator']
  },
  handles: context => {
    const {
      streetView
    } = context;
    const mapEditing = UI.get(GlobalState.get(), 'mapEditing');
    return mapEditing !== true && !streetView;
  },
  appearance: () => {
    return {
      name: 'Map Key',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/map-icons/map-key-button.png'
    };
  },
  perform: props => {
    const {
      context: {
        clientProps: {
          objectType
        }
      }
    } = props;
    const upperCaseObjectType = objectType === 'locator' ? 'Locator' : 'Vehicle';
    const titleBarText = `${upperCaseObjectType} Map Key`;
    Dialogs.show({
      component: MapKeyResponsive,
      props: {
        titleBarText,
        objectType
      }
    });
  }
};